import Vue from 'vue'
import App from './App.vue'
// import 'lib-flexible'
import axios from 'axios'
import CryptoJS from 'crypto-js'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/zh-TW'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueCookies from 'vue-cookies'
import router from './router'
import store from './store'
import http from './utils/config'
import utils from './utils/urlGet'

Vue.use(ElementUI, {
  locale
})

import '@Assets/css/common.css'
import '@Assets/fonts/iconfont.css'
import '@pcAssets/styles/animate.css'
import 'animate.css'
import 'element-ui/lib/theme-chalk/index.css'
import {
  Actionsheet,
  DatetimePicker,
  MessageBox,
  Picker,
  Popup,
  Toast
} from 'mint-ui'
import 'mint-ui/lib/style.css'
import 'swiper/css/swiper.css'
import Vant, {
  DropdownItem,
  DropdownMenu
} from 'vant'
import 'vant/lib/index.css'
import VueBus from 'vue-bus'
import VueClipboard from 'vue-clipboard2'
import FBSignInButton from 'vue-facebook-signin-button'
import layer from 'vue-layer'
import 'vue-layer/lib/vue-layer.css'
import './assets/styles/common.css'
import './assets/styles/pcMedia.css'

Vue.component(DatetimePicker.name, DatetimePicker);
Vue.component(Picker.name, Picker);
Vue.use(Vant);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.component(Toast);
Vue.component(Popup.name, Popup);
Vue.component(Actionsheet.name, Actionsheet);
Vue.use(FBSignInButton)
Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper)
Vue.use(VueCookies)
Vue.use(VueBus)
Vue.use(VueClipboard)
// import VConsole from 'vconsole/dist/vconsole.min.js'
// let vConsole = new VConsole()
// Vue.use(VueToast)
//全局使用，挂载到原型上
Vue.prototype.$layer = layer(Vue)
Vue.prototype.CryptoJS = CryptoJS
Vue.prototype.$messagebox = MessageBox

/* axios配置 */
//axios.defaults.withCredentials = true
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
Vue.prototype.$utils = utils;
Vue.prototype.$http = axios;
Vue.prototype.$axios = http;
var querystring = require('querystring');

// 正式服
var baseUrl = "https://api.hermesgames.com.tw";
// 测试服
// var baseUrl = "http://testick.api.iclockwork.com"

/*
 * 封装ajax
 * obj : 全局this
 * data : ajax传入后台data数据
 * address : ajax接口地址
 * fn : 成功返回方法  带参数  obj,data  obj:this, data:response
 * */

Vue.prototype.postHttp = function (obj, data, address, fn) {
  http.post(baseUrl + address, data).then(response => {
    fn(obj, response);
  }, response => {

  })
}

Vue.prototype.getHttp = function (obj, data, address, fn) {
  http.get(baseUrl + address, {
    params: data
  }).then(function (response) {
    fn(obj, response)
  }).catch(function (response) {

  });
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')


// 页面进入后再进行终端判断跳转总共四个链接
// setTimeout(() => {
// 	requireParams();
// }, 1000)

/**
 * 截取地址栏参数,调取第三方登录接口
 */
// function requireParams() {
// 	let account = Vue.prototype.$utils.getUrlKey("account");
// 	let name = Vue.prototype.$utils.getUrlKey("name");
// 	let token = Vue.prototype.$utils.getUrlKey("token");
// 	let type = Vue.prototype.$utils.getUrlKey("type");
// 	let signature = Vue.prototype.$utils.getUrlKey("signature");
// 	if (account && name && token && type) {
// 		let datas = {
// 			account: account,
// 			name: name,
// 			token: token,
// 			type: type,
// 		};
// 		Vue.prototype.postHttp(this, datas, "/front/others/login", function (
// 			obj,
// 			data
// 		) {
// 			if (data.status == "2000") {
// 				store.commit('setIsHmsLogin', false);
// 				let token = data.data.bear_token;
// 				let userInfo = data.data.user_info;
// 				store.commit("setToken", token);
// 				store.commit("setUserInfo", userInfo);
// 				localStorage.setItem("token", token);
// 				localStorage.setItem(
// 					"userInfo",
// 					JSON.stringify(userInfo)
// 				);
// 			} else {
// 			}
// 			Toast(data.message);
// 		});
// 	} else {}
// }
